var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullbox"},[_c('div',{staticClass:"fullbox_top"},[_vm._v("随手拍月度汇总数据")]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"fullbox_table fullbox_table1"},[_c('pcTable',{attrs:{"tableData":_vm.tableSaleAll}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }